import { Component, inject, input, output, computed } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ThemeService } from '../../../core/services/theme.service';

export interface AlertasData {
  title?: string;
  message?: string;
  subtitle?: string;
  confirmText?: string;
  cancelText?: string;
  showCancel?: boolean;
}

@Component({
  selector: 'app-alertas',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './alertas.html',
  styleUrl: './alertas.scss',
})
export class Alertas {
  private dialogRef = inject(MatDialogRef<Alertas>, { optional: true });
  protected data = inject<AlertasData>(MAT_DIALOG_DATA, { optional: true });
  private themeService = inject(ThemeService);

  // Inputs independientes para uso directo como componente
  titleInput = input<string>();
  messageInput = input<string>();
  subtitleInput = input<string>();
  confirmTextInput = input<string>();
  cancelTextInput = input<string>();
  showCancelInput = input<boolean | undefined>(undefined);

  // Outputs para eventos cuando se renderiza sin MatDialog
  confirmClick = output<void>();
  cancelClick = output<void>();

  // Prioridad de resolucion: MAT_DIALOG_DATA > input() > texto por defecto
  title = computed(() => this.data?.title ?? this.titleInput() ?? 'Advertencia');
  message = computed(() => this.data?.message ?? this.messageInput() ?? 'Esta acción es irreversible');
  subtitle = computed(() => this.data?.subtitle ?? this.subtitleInput() ?? '¿Desea continuar con la operación?');
  confirmText = computed(() => this.data?.confirmText ?? this.confirmTextInput() ?? 'Continuar');
  cancelText = computed(() => this.data?.cancelText ?? this.cancelTextInput() ?? 'Atrás');
  showCancel = computed(() => this.data?.showCancel ?? this.showCancelInput() ?? true);

  // Ruta dinamica del SVG según el tema activo (Light/Dark)
  iconUrl = computed(() =>
    this.themeService.isDarkMode()
      ? 'assets/icons/Advertencia_DT.svg'
      : 'assets/icons/Advertencia_LT.svg'
  );

  onConfirm(): void {
    this.confirmClick.emit();
    if (this.dialogRef) {
      this.dialogRef.close(true);
    }
  }

  onCancel(): void {
    this.cancelClick.emit();
    if (this.dialogRef) {
      this.dialogRef.close(false);
    }
  }
}
